import React from "react";
import { useHistory } from 'react-router-dom';
import axios from 'axios';

import {
  Button,
  Navbar,
  Container,
} from "react-bootstrap";

function AdminNavbar() {

  const [collapseOpen, setCollapseOpen] = React.useState(false);

  const handleLogout = () => {

    const token = JSON.parse(localStorage.getItem('authenticated'))?.token;
    localStorage.removeItem('authenticated');
    window.location.href = `${process.env.REACT_APP_API_HOST}auth/logout?access_token=${token}`;
    return;

  }

  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize">
              <Button
                className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
                variant="dark"
                onClick={() => document.body.classList.toggle("sidebar-mini")}
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
              <Button
                className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
                variant="dark"
                onClick={() =>
                  document.documentElement.classList.toggle("nav-open")
                }
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
            </div>
            <Navbar.Brand href="#pablo" onClick={(e) => e.preventDefault()}></Navbar.Brand>
          </div>
          <button
            className="navbar-toggler navbar-toggler-right border-0"
            type="button"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
          </button>
          <Navbar className="justify-content-end">
            <Button
              className="btn-fill btn-icon d-none d-lg-block bg-dark border-dark"
              variant="dark"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Navbar>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
